import {
    HTTP,
    HTTP_AUTH
} from '../http-common'

const snackbarDefaults = {
    info: {
        color: 'info',
        icon: 'mdi-check',
        text: ''
    },
    error: {
        color: 'error',
        icon: 'mdi-alert',
        text: 'Помилка! '
    }
}

export default {
    state: {
        error: false,
        userInfo: {},
        navigationDrawerRightOpened: false,
        snackbar: {
            model: false,
            color: '',
            icon: '',
            text: ''
        },
        loading: false,
        userInfoLoading: false,
        servicesList: [],
        referenceList: {},
        emptyServiceList: false,
        background: {
            default: 'login-background',
            adminpanel: 'admin-panel-background',
            'users': 'admin-panel-background',
            'admins': 'admin-panel-background',
            'megogo-list': 'admin-panel-background',
            'megogo-service': 'admin-panel-background',
            'megogo-package-selling': 'admin-panel-background',
            'megogo-package-selling-history': 'admin-panel-background',

            'youtv-list': 'admin-panel-background',
            'youtv-service': 'admin-panel-background',
            'youtv-package-selling': 'admin-panel-background',
            'youtv-package-selling-history': 'admin-panel-background',

            'megogo': 'megogo-home-background',
            'megogo-buy': 'megogo-home-background',
            'megogo-success': 'megogo-home-background',
            'megogo-clarification' : 'megogo-home-background',

            'youtv': 'youtv-home-background',
            'youtv-buy': 'youtv-home-background',
            'youtv-success': 'youtv-home-background',
            'youtv-clarification' : 'youtv-home-background',
        },
    },
    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload
        },
        updateSnackbar(state, payload) {
            state.snackbar = payload
        },
        openCloseNavigationDrawerRight(state, payload) {
            state.navigationDrawerRightOpened = payload
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setServicesList(state, payload) {
            state.servicesList = payload
        },
        setEmptyServiceList(state, payload) {
            state.emptyServiceList = payload
        },
        setBackground(state, payload) {
            state.background = payload
        },
        setReferenceList(state, payload) {
            state.referenceList = payload
        },
    },
    actions: {
        touch() {
            return new Promise((resolve, reject) => {
                HTTP.post('/services/touch')
                    .then(() => resolve())
                    .catch(error => reject(error))
            })
        },
        getUserInfo({
            commit,
            state,
            dispatch
        }, refresh) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {
                // Кэширование
                // if (state.userInfo && state.userInfo.id > 0 && !refresh) {
                //     state.userInfoLoading = false
                //     state.loading = false
                //     resolve(state.userInfo)
                // } else {
                    HTTP.post('/auth/user-info')
                        .then(response => {
                            state.userInfoLoading = false
                            state.loading = false
                            if (response.data && response.data.content) {
                                commit('setUserInfo', response.data.content)
                                resolve(response.data.content)
                            } else {
                                commit('setUserInfo', {
                                    id: 0
                                })
                            }
                        })
                        .catch(error => {
                            state.userInfoLoading = false
                            state.loading = false
                            commit('setUserInfo', {
                                id: 0
                            })
                            if (error.response && error.response.status === 401) {
                                resolve(error.response)
                            } else {
                                state.error = true
                                dispatch('setSnackbar', ['error', error])
                                reject(error)
                            }
                        })
                //}
            })
        },
        login({
            commit,
            state,
            dispatch
        }, data) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {

                //HTTP.post('http://cms.yugcontract.ua:5002/auth/code', data)
                HTTP_AUTH.post('/auth/login', data)
                    .then(response => {
                        state.userInfoLoading = false
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.userInfoLoading = false
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        verify({
            commit,
            state,
            dispatch
        }, data) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP_AUTH.post('/auth/verify', data)
                    .then(response => {
                        state.userInfoLoading = false
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.userInfoLoading = false
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error])
                        reject(error)
                    })
            })
        },
        register({
            commit,
            state,
            dispatch
        }, data) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP_AUTH.post('/auth/register', data)
                    .then(response => {
                        state.userInfoLoading = false
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.userInfoLoading = false
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error])
                        reject(error)
                    })
            })
        },
        verifyRegistration({
            commit,
            state,
            dispatch
        }, data) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP_AUTH.post('/auth/verify-registration', data)
                    .then(response => {
                        state.userInfoLoading = false
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.userInfoLoading = false
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error])
                        reject(error)
                    })
            })
        },
        sendEmailRequest({
            commit,
            state,
            dispatch
        }, data) {
            state.userInfoLoading = true
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP.post('/services/send-request', data)
                    .then(response => {
                        state.userInfoLoading = false
                        state.loading = false
                        dispatch('setSnackbar', ['info', 'Дякуємо. Ваше звернення буде опрацьовано протягом доби'])
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.userInfoLoading = false
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error])
                        reject(error)
                    })
            })
        },
        getReferenceList(c) {
            return new Promise((resolve, reject) => {
                HTTP.get('/services/reference-list')
                    .then(response => {
                        c.commit('setReferenceList', response.data.content)
                        resolve(response)
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },
        logOut(c) {
            return new Promise((resolve, reject) => {
                HTTP_AUTH.delete('/auth/logout')
                    .then(response => {
                        localStorage.removeItem("authToken")
                        localStorage.removeItem("refreshToken")
                        c.commit('setUserInfo', {
                            id: 0
                        })
                        resolve(response)
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },
        servicesList({
            commit
        }) {
            return new Promise((resolve, reject) => {
                HTTP.get('/services/list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setServicesList', response.data.content)
                            if (response.data.content.length === 0) {
                                commit('setEmptyServiceList', true)
                            }
                            resolve(response.data.content)
                        } else {
                            commit('setServicesList', [])
                            resolve([])
                        }
                    })
                    .catch(e => {
                        console.error(e)
                        reject(e)
                    })
            })
        },
        setSnackbar({
            commit
        }, [type, text]) {
            let data = {
                ...snackbarDefaults[type],
                text: snackbarDefaults[type || 'error'].text + (text || ''),
                model: true
            }
            commit('updateSnackbar', data)
        },
    },
    getters: {
        userInfo(state) {
            return state.userInfo
        },
        snackbar(state) {
            return state.snackbar
        },
        backGround: state => id => {
            return state.background[id] !== undefined ? state.background[id] : state.background['default']
        }
    }
}